module.exports = __webpack_public_path__ + "fea50278cc998e6a6ed7c4da5906bee7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/mouse-ears.png
// module id = 2929
// module chunks = 0